module.exports = __webpack_public_path__ + "img/09.b73d3da0.png";